import React from 'react';

function Content({ classes, children }) {
  return <div className={classes}>{children}</div>;
}

export default Content;
